import React, { useEffect, useState } from "react";
import TopNavigation from "../../../components/TopNavigation";
import { Base } from "../../../components/RootLayout";
import { connect } from "react-redux";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";

const InvitMembers = (p) => {
  const {
    getListMembers,
    getListMembersWithParams,
    listMembers,
    payload,
    setPayload,
    setIsInvitMember,
  } = p;
  const [keyword, setKeyword] = useState("");

  const searchAction = (e) => {
    setKeyword(e.target.value);
  };

  const handleClickMembers = (data) => {
    let checkData = payload.members.filter((a) => a.pk === data.pk);
    if (checkData.length < 1) {
      let addData = [...payload.members];
      addData.push(data);
      setPayload((prevState) => ({
        ...prevState,
        members: addData,
      }));
    }
    setIsInvitMember(false);
    setKeyword("");
  };

  const handleBackToReminder = () => {
    p.setIsInvitMember(false);
    setKeyword("");
  };

  useEffect(() => {
    if (keyword.length < 1) {
      getListMembers();
    } else {
      getListMembersWithParams(keyword);
    }
  }, [keyword, setIsInvitMember]);

  return (
    <Base>
      <TopNavigation
        titlePage="Invite Members"
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
        isCustomLeftNavigation={true}
        onClickLeftCustom={handleBackToReminder}
      />
      <div className="invit-members-wrapper">
        <input
          type="text"
          placeholder="Search"
          value={keyword}
          onChange={searchAction}
        />
        {listMembers &&
          listMembers.map((data, idx) => (
            <div
              key={idx}
              className="member-list"
              onClick={() => handleClickMembers(data)}
            >
              {data.first_name} {data.last_name}, {data.email}
            </div>
          ))}
        {listMembers.length < 1 && (
          <div className="no-data">
            <span>No Data Found</span>
          </div>
        )}
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  listMembers: state.CalendarSM.listMembers,
});

const mapDispatchToProps = (dispatch) => ({
  getListMembers: dispatch.CalendarSM.getListMembers,
  getListMembersWithParams: dispatch.CalendarSM.getListMembersWithParams,
});

export default connect(mapStateToProps, mapDispatchToProps)(InvitMembers);
